import { reducers as appReducers } from '../app/store/reducers';
import { reducers as virtualReducers } from '../virtual/store/reducers';

export const configReducers: any = {
	app: appReducers,
	virtual: virtualReducers
};

export default configReducers;
